module.exports = __webpack_public_path__ + "img/hockey-dark.08d6186c.svg";